module.exports = __webpack_public_path__ + "img/pillows.4387166a.png";